// Function to extract YouTubeVideoID from a YouTube url
function getYouTubeVideoID (fullURL) {
    try {
        const urlObj = new URL(fullURL);

        // Handle YouTube short links
        if (urlObj.hostname === "youtu.be") {
            return urlObj.pathname.slice(1); // removes leading "/"
        }

        // Handle full length YouTube urls
        if (urlObj.hostname === "youtube.com") {
            return urlObj.searchParams.get("v");
        }

        return null;

    } catch (error) {
        console.error("Invalid YouTube URL: ", fullURL);
        return null;
    }
}

function YouTubeEmbed ({ url, propertyName }) {
    if (!url) return null;
    const videoID = getYouTubeVideoID(url);

    if (!videoID) return null;
    const embedURL = `https://www.youtube.com/embed/${videoID}`;

    return (
        <div className="d-flex justify-content-center"> {/* To centralize ifram container */}
            <div
                className="ratio ratio-16x9"
                style={{ maxWidth: "560px", width: "100%" }}
            > {/* ifram container: To manage aspect ratio of iframe */}
                <iframe
                    src={ embedURL }
                    title={ propertyName }
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                >
                </iframe>
            </div>
        </div>
    )
}

export default YouTubeEmbed;